module.exports = __webpack_public_path__ + "img/circuit-diagram.297a52ec.png";